// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"7251a5ef","606":"cb25491c"}[chunkId] + ".js";
};